import * as React from 'react';
import { cn } from '@/lib/utils';

interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string;
  error?: string;
  helperText?: string;
}

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, label, error, helperText, id, ...props }, ref) => {
    const generatedId = React.useId();
    const textareaId = id ?? generatedId;

    return (
      <div className="w-full">
        {label && (
          <label
            htmlFor={textareaId}
            className="block text-xs font-medium text-raios-text-secondary mb-1.5"
          >
            {label}
          </label>
        )}
        <textarea
          id={textareaId}
          ref={ref}
          className={cn(
            // text-base no mobile (16px): evita o auto-zoom do iOS ao focar (mesmo fix do Input).
            'flex w-full bg-raios-card border border-raios-border rounded-md text-base sm:text-sm text-raios-text placeholder:text-raios-muted min-h-[80px] px-3 py-2 transition-colors resize-y',
            'focus:outline-none focus:ring-2 focus:ring-raios-accent/40 focus:border-raios-accent',
            'disabled:opacity-50 disabled:cursor-not-allowed',
            error && 'border-raios-danger focus:ring-raios-danger/40 focus:border-raios-danger',
            className
          )}
          aria-invalid={error ? true : undefined}
          aria-describedby={
            error ? `${textareaId}-error` : helperText ? `${textareaId}-helper` : undefined
          }
          {...props}
        />
        {error && (
          <p id={`${textareaId}-error`} className="mt-1.5 text-xs text-raios-danger-text">
            {error}
          </p>
        )}
        {!error && helperText && (
          <p id={`${textareaId}-helper`} className="mt-1.5 text-xs text-raios-muted">
            {helperText}
          </p>
        )}
      </div>
    );
  }
);

Textarea.displayName = 'Textarea';

export { Textarea };
export type { TextareaProps };
